import type { FaireProductEntity } from "../../entity_types/product";

export const p_ahqcqy4r76: FaireProductEntity = {
  token: "p_ahqcqy4r76",
  type: "product",
  name: "Looking Forward To Breakfast Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/8ce62940ee74c31b0a3f951d30e592885a462d141d6a78a1d583102c59d55766.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e96632bc6a587f902cbec6a00e58156b193c76aef0b4a0ae027ce8b2e0100db6.jpeg",
    "https://cdn.faire.com/fastly/0f8b80d8eb9adfc9e6159b73ad23b08ed78a708464bd0c1485d9d04e9a66f096.jpeg",
    "https://cdn.faire.com/fastly/e15bb731af09a31cdb724afd21d8d39ce1cdfa822ebf4ccd2b65f3789c3d88a5.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying hand illustrated designs of breakfast items with a fun sentiment that reads \"Only Looking Forward To Breakfast\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Breakfast metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:28.813Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
